(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auro-daily-habit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-habit-reveal')) {
  customElements.define('auro-habit-reveal', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.root = this.closest('.auro-habit');
      if (!this.root || this.root.dataset.motion !== 'true') return;
      this.seen = this.seen || new WeakSet();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => this.observeEntrances();
      this.motion.addEventListener('change', this.onMotionChange);
      this.onBlockSelect = (event) => {
        const step = event.target.closest?.('.auro-habit__step');
        if (step && this.contains(step) && !this.motion.matches) this.reveal(step, 0);
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.observeEntrances();
    }
    observeEntrances() {
      this.observer?.disconnect();
      if (this.motion.matches || typeof IntersectionObserver === 'undefined') return;
      this.observer = new IntersectionObserver((entries) => {
        if (!this.isConnected || this.motion.matches) return;
        let order = 0;
        for (const entry of entries) {
          if (!entry.isIntersecting || this.motion.matches) continue;
          this.reveal(entry.target, Math.min(order++, 3) * 90);
          this.observer.unobserve(entry.target);
        }
      }, { threshold: 0, rootMargin: '0px 0px -8px 0px' });
      this.querySelectorAll('.auro-habit__intro, .auro-habit__step').forEach((node) => {
        if (!this.seen.has(node)) this.observer.observe(node);
      });
    }
    reveal(node, delay) {
      if (this.seen.has(node)) return;
      this.seen.add(node);
      node.style.setProperty('--auro-habit-enter-delay', `${delay}ms`);
      node.classList.add('is-entering');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.motion && this.onMotionChange) this.motion.removeEventListener('change', this.onMotionChange);
      if (this.onBlockSelect) this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-luna-faq')) {
  class AuroLunaFaq extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('toggle', (event) => {
        const item = event.target;
        if (this.dataset.singleOpen !== 'true' || !item.matches('.afq-item') || !item.open) return;
        this.querySelectorAll('.afq-item[open]').forEach((other) => {
          if (other !== item) other.open = false;
        });
      }, { ...options, capture: true });
      this.addEventListener('keydown', (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const current = event.target.closest('.afq-question');
        if (!current || !this.contains(current)) return;
        const summaries = Array.from(this.querySelectorAll('.afq-question'));
        const index = summaries.indexOf(current);
        if (index < 0) return;
        let target;
        if (event.key === 'ArrowDown') target = (index + 1) % summaries.length;
        else if (event.key === 'ArrowUp') target = (index - 1 + summaries.length) % summaries.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = summaries.length - 1;
        else return;
        event.preventDefault();
        summaries[target].focus();
      }, options);
      if (this.hasAttribute('data-editor')) {
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.afq-item');
          if (item && this.contains(item)) item.open = true;
        }, options);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
  }
  customElements.define('auro-luna-faq', AuroLunaFaq);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-footer-newsletter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-footer-v3')) {
  class AuroFooter extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.mobile = matchMedia('(max-width:749px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.menus = [...this.querySelectorAll('[data-footer-menu]')];
      this.animations = new Map();
      this.epochs = new Map();
      this.applyLayout();
      this.mobile.addEventListener('change', () => this.applyLayout(), { signal: this.abort.signal });
      this.reduced.addEventListener('change', () => {
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
        this.menus.forEach(menu => this.setOpen(menu, menu.dataset.targetOpen === 'true'));
      }, { signal: this.abort.signal });
      this.addEventListener('click', event => {
        const summary = event.target.closest('[data-menu-summary]');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        if (this.mobile.matches && this.dataset.accordion === 'true') this.toggle(summary.parentElement);
      }, { signal: this.abort.signal });
      document.addEventListener('shopify:block:select', event => {
        const menu = this.menus.find(item => item.dataset.blockId === event.detail.blockId);
        if (menu) this.setOpen(menu, true);
      }, { signal: this.abort.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (this.canAnimate() && entry.target.animate) {
              const animation = entry.target.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 600, easing: 'cubic-bezier(.22,1,.36,1)' });
              this.track(entry.target, animation);
            }
          });
        }, { threshold: .08 });
        this.querySelectorAll('[data-footer-reveal]').forEach(element => this.observer.observe(element));
      }
    }
    canAnimate() { return this.dataset.animate === 'true' && !this.reduced.matches; }
    track(element, animation) {
      this.animations.get(element)?.cancel();
      this.animations.set(element, animation);
      animation.finished.catch(() => {}).finally(() => { if (this.animations.get(element) === animation) this.animations.delete(element); });
    }
    setOpen(menu, open) {
      const content = menu.querySelector('[data-menu-content]');
      this.epochs.set(menu, (this.epochs.get(menu) || 0) + 1);
      this.animations.get(content)?.cancel();
      menu.open = open;
      menu.dataset.targetOpen = String(open);
    }
    applyLayout() {
      this.animations.forEach(animation => animation.cancel());
      this.animations.clear();
      const accordion = this.mobile.matches && this.dataset.accordion === 'true';
      this.menus.forEach(menu => {
        this.setOpen(menu, !accordion);
        const summary = menu.querySelector('[data-menu-summary]');
        summary.tabIndex = accordion ? 0 : -1;
        if (accordion) summary.removeAttribute('aria-disabled'); else summary.setAttribute('aria-disabled', 'true');
      });
    }
    toggle(menu) {
      const content = menu.querySelector('[data-menu-content]');
      const open = menu.dataset.targetOpen !== 'true';
      const from = content.getBoundingClientRect().height;
      this.animations.get(content)?.cancel();
      const epoch = (this.epochs.get(menu) || 0) + 1;
      this.epochs.set(menu, epoch);
      menu.dataset.targetOpen = String(open);
      menu.open = true;
      if (!this.canAnimate() || !content.animate) { menu.open = open; return; }
      const to = open ? content.scrollHeight : 0;
      const animation = content.animate([{ height: `${from}px`, opacity: open ? .4 : 1 }, { height: `${to}px`, opacity: open ? 1 : 0 }], { duration: 260, easing: 'cubic-bezier(.22,1,.36,1)' });
      this.track(content, animation);
      animation.finished.then(() => { if (this.epochs.get(menu) === epoch) menu.open = open; }).catch(() => {});
    }
    disconnectedCallback() {
      if (!this.abort) return;
      this.abort.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.animations.forEach(animation => animation.cancel());
      this.animations.clear();
      this.menus.forEach(menu => { menu.open = true; });
    }
  }
  customElements.define('auro-footer-v3', AuroFooter);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-navigation-v3')) {
  customElements.define('auro-navigation-v3', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.abort) return;
      this.root = this.closest('[data-auro-header]');
      if (!this.root) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.bar = this.root.querySelector('.auh-bar');
      this.mobile = this.root.querySelector('.auh-mobile-menu');
      this.disclosures = [...this.root.querySelectorAll('[data-auh-disclosure]')];
      this.states = new Map();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = matchMedia(`(min-width:${Number(this.root.dataset.breakpoint) || 1024}px)`);
      this.hover = matchMedia('(hover: hover) and (pointer: fine)');
      this.generation = 0;
      this.alive = true;
      const listen = (target, name, fn, options = {}) => target?.addEventListener(name, fn, { ...options, signal });
      this.isDesktop = () => this.desktop.matches && this.root.dataset.layout !== 'compact';
      this.scheduleMeasure = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.measure(); });
      };

      for (const details of this.disclosures) {
        const summary = details.querySelector(':scope > summary');
        const panel = details.querySelector(':scope > [data-auh-panel]');
        if (!summary || !panel) continue;
        const state = { summary, panel, animation: null, closing: false, timer: 0 };
        this.states.set(details, state);
        summary.setAttribute('aria-expanded', String(details.open));
        listen(summary, 'click', event => {
          event.preventDefault();
          this.setOpen(details, !details.open || state.closing);
        });
        listen(details, 'toggle', () => {
          if (!state.closing) this.sync(details);
        });
        listen(summary, 'keydown', event => {
          if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
          event.preventDefault();
          this.setOpen(details, true);
          const links = [...panel.querySelectorAll('a[href]')];
          (event.key === 'ArrowUp' ? links.at(-1) : links[0])?.focus();
        });
        if (details !== this.mobile && !this.mobile.contains(details)) {
          listen(details, 'pointerenter', event => {
            clearTimeout(state.timer);
            if (event.pointerType === 'mouse' && this.root.dataset.hover === 'true' && this.hover.matches && this.isDesktop()) this.setOpen(details, true);
          });
          listen(details, 'pointerleave', () => {
            if (this.root.dataset.hover !== 'true' || !this.hover.matches || !this.isDesktop()) return;
            state.timer = setTimeout(() => {
              if (!details.contains(document.activeElement)) this.setOpen(details, false);
            }, 150);
          });
        }
      }

      listen(document, 'pointerdown', event => {
        for (const details of this.disclosures) if (details.open && !details.contains(event.target)) this.setOpen(details, false);
      });
      listen(document, 'focusin', event => {
        for (const details of this.disclosures) if (details.open && !details.contains(event.target)) this.setOpen(details, false);
      });
      listen(document, 'keydown', event => {
        if (event.key !== 'Escape') return;
        const nearest = document.activeElement?.closest('[data-auh-disclosure][open]');
        const target = nearest && this.root.contains(nearest) ? nearest : this.disclosures.find(details => details.open && !this.mobile.contains(details));
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        this.setOpen(target, false, true);
      });
      listen(this.root, 'click', event => {
        if (!event.target.closest('a[href]')) return;
        for (const details of this.disclosures) this.setOpen(details, false, false, true);
      });
      listen(this.root, 'keydown', event => {
        if (!this.isDesktop() || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        const panel = event.target.closest('.auh-dropdown');
        if (!panel) return;
        const links = [...panel.querySelectorAll('a[href]')];
        const index = links.indexOf(event.target);
        if (index < 0) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links[next]?.focus();
      });

      listen(window, 'resize', this.scheduleMeasure, { passive: true });
      listen(window.visualViewport, 'resize', this.scheduleMeasure, { passive: true });
      listen(window.visualViewport, 'scroll', this.scheduleMeasure, { passive: true });
      listen(this.desktop, 'change', () => {
        const focusWasInMenu = this.disclosures.some(details => details.contains(document.activeElement));
        for (const details of this.disclosures) this.setOpen(details, false, false, true);
        this.measure();
        if (focusWasInMenu) (this.isDesktop() ? this.root.querySelector('.auh-logo') : this.states.get(this.mobile)?.summary)?.focus({ preventScroll: true });
        this.scheduleMeasure();
      });
      listen(this.reduced, 'change', () => {
        for (const [details, state] of this.states) {
          state.animation?.cancel();
          if (state.closing) this.setOpen(details, false, false, true);
        }
      });
      listen(window, 'scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.root.dataset.scrolled = String(window.scrollY > 8);
          if (this.mobile.open) this.measureAvailable();
        });
      }, { passive: true });

      const scheduleCart = event => {
        const candidates = [event?.detail?.cart, event?.detail?.data?.cart, event?.detail?.data, event?.detail];
        const cart = candidates.find(value => Number.isInteger(value?.item_count) && value.item_count >= 0);
        if (cart) {
          clearTimeout(this.cartTimer);
          this.request?.abort();
          this.generation++;
          this.paintCart(cart.item_count);
          return;
        }
        clearTimeout(this.cartTimer);
        this.cartTimer = setTimeout(() => this.refreshCart(), 160);
      };
      for (const event of ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change', 'product:added', 'ajaxProduct:added']) listen(document, event, scheduleCart);
      listen(window, 'pageshow', scheduleCart);
      listen(document, 'visibilitychange', () => { if (!document.hidden) scheduleCart(); });
      listen(document, 'shopify:block:select', event => {
        if (event.detail?.sectionId !== this.root.id.replace('AuroHeader-', '')) return;
        const id = event.detail?.blockId;
        const nodes = [...this.root.querySelectorAll('[data-auh-block]')];
        const selected = nodes.find(el => el.dataset.auhBlock === id && (this.isDesktop() ? !this.mobile.contains(el) : this.mobile.contains(el)));
        if (!selected) return;
        if (this.mobile.contains(selected)) this.setOpen(this.mobile, true);
        const dropdown = selected.querySelector('[data-auh-disclosure]');
        if (dropdown) this.setOpen(dropdown, true);
      });

      this.group = this.root.closest('#header-group, .header-group');
      this.offsetProperty = '--auh-sticky-offset-' + this.root.id.replace('AuroHeader-', '');
      this.observer = new ResizeObserver(entries => {
        let changed = false;
        for (const entry of entries) {
          if (entry.target !== this.bar || Math.abs(entry.contentRect.width - (this.lastBarWidth || 0)) > .5) changed = true;
          if (entry.target === this.bar) this.lastBarWidth = entry.contentRect.width;
        }
        if (changed) this.scheduleMeasure();
      });
      this.observer.observe(this.bar);
      if (this.group) for (const child of this.group.children) this.observer.observe(child);
      document.fonts?.ready.then(() => { if (this.alive) this.scheduleMeasure(); });
      this.root.dataset.scrolled = String(window.scrollY > 8);
      this.measure();
    }

    sync(details) {
      const state = this.states.get(details);
      if (!state) return;
      state.summary.setAttribute('aria-expanded', String(details.open && !state.closing));
      if (details === this.mobile) state.summary.setAttribute('aria-label', details.open && !state.closing ? this.root.dataset.closeLabel : this.root.dataset.openLabel);
    }

    duration() {
      if (this.reduced.matches || this.root.dataset.animate !== 'true') return 0;
      return parseFloat(getComputedStyle(this.root).getPropertyValue('--auh-duration-number')) || 0;
    }

    setOpen(details, open, restore = false, immediate = false) {
      const state = this.states.get(details);
      if (!state || (!open && !details.open)) return;
      clearTimeout(state.timer);
      state.animation?.cancel();
      state.animation = null;
      state.closing = false;
      delete details.dataset.closing;
      state.panel.inert = false;
      if (open) {
        const wasOpen = details.open;
        for (const other of this.disclosures) {
          if (other !== details && !other.contains(details) && !details.contains(other) && other.open) this.setOpen(other, false, false, true);
        }
        details.open = true;
        this.sync(details);
        this.measureAvailable();
        if (!wasOpen && !immediate && this.duration() && state.panel.animate) {
          state.animation = state.panel.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: this.duration(), easing: 'cubic-bezier(.22,1,.36,1)' });
          state.animation.finished.catch(() => {});
        }
        return;
      }
      if (restore) state.summary.focus({ preventScroll: true });
      for (const child of this.disclosures) if (child !== details && details.contains(child)) this.setOpen(child, false, false, true);
      const finish = () => {
        details.open = false;
        state.closing = false;
        delete details.dataset.closing;
        state.panel.inert = false;
        state.animation = null;
        this.sync(details);
      };
      if (!immediate && this.duration() && state.panel.animate) {
        state.closing = true;
        details.dataset.closing = '';
        state.panel.inert = true;
        this.sync(details);
        const animation = state.panel.animate([{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-4px)' }], { duration: Math.round(this.duration() * .65), easing: 'ease-in' });
        state.animation = animation;
        animation.finished.then(() => { if (state.animation === animation) finish(); }).catch(() => {});
      } else finish();
    }

    measure() {
      const wasCompact = this.root.dataset.layout === 'compact';
      const focusWasInMenu = this.disclosures.some(details => details.contains(document.activeElement));
      delete this.root.dataset.layout;
      if (this.desktop.matches) {
        const nav = this.root.querySelector('.auh-desktop-nav');
        const logo = this.root.querySelector('.auh-logo');
        const bag = this.root.querySelector('.auh-bag');
        const style = getComputedStyle(this.bar);
        const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        const gap = parseFloat(style.columnGap) || 0;
        const side = Math.max(logo.getBoundingClientRect().width, bag.scrollWidth + 2);
        const navList = nav.querySelector(':scope > ul');
        const items = navList ? [...navList.children] : [];
        const navGap = navList ? parseFloat(getComputedStyle(navList).columnGap) || 0 : 0;
        const navWidth = items.length ? items.reduce((sum, item) => sum + item.getBoundingClientRect().width, 0) + navGap * (items.length - 1) : nav.scrollWidth;
        const required = navWidth + side * 2 + gap * 2 + padding;
        if (required > this.bar.getBoundingClientRect().width + 1) this.root.dataset.layout = 'compact';
      }
      if (wasCompact !== (this.root.dataset.layout === 'compact')) {
        for (const details of this.disclosures) this.setOpen(details, false, false, true);
        if (focusWasInMenu) (this.isDesktop() ? this.root.querySelector('.auh-logo') : this.states.get(this.mobile)?.summary)?.focus({ preventScroll: true });
      }
      if (this.isDesktop() && this.mobile.open) {
        this.setOpen(this.mobile, false, false, true);
        this.root.querySelector('.auh-logo')?.focus({ preventScroll: true });
      }
      if (this.group && this.root.dataset.sticky === 'true') {
        const offset = Math.max(0, Math.round(this.root.getBoundingClientRect().top - this.group.getBoundingClientRect().top));
        this.group.style.setProperty(this.offsetProperty, offset + 'px');
      }
      this.measureAvailable();
    }

    measureAvailable() {
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      this.root.style.setProperty('--auh-panel-available', Math.max(0, Math.floor(bottom - this.bar.getBoundingClientRect().bottom - 8)) + 'px');
      for (const [details, state] of this.states) {
        if (!details.open || this.mobile.contains(details) || details === this.mobile) continue;
        state.panel.removeAttribute('data-align');
        if (state.panel.getBoundingClientRect().right > window.innerWidth - 16) state.panel.dataset.align = 'end';
        this.root.style.setProperty('--auh-dropdown-available', Math.max(0, Math.floor(bottom - state.summary.getBoundingClientRect().bottom - 28)) + 'px');
      }
    }

    paintCart(count) {
      if (!Number.isInteger(count) || count < 0 || !this.alive) return;
      this.root.querySelector('[data-auro-cart-count]').textContent = String(count);
      const bag = this.root.querySelector('.auh-bag');
      const label = this.root.querySelector('[data-auh-bag-label]').textContent;
      bag.setAttribute('aria-label', `${label}: ${count} ${this.root.dataset.cartLabel}`);
    }

    async refreshCart() {
      this.request?.abort();
      this.request = new AbortController();
      const generation = ++this.generation;
      try {
        const response = await fetch(this.root.dataset.cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store', signal: this.request.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (generation === this.generation) this.paintCart(cart.item_count);
      } catch (error) {}
    }

    disconnectedCallback() {
      this.alive = false;
      this.abort?.abort();
      this.abort = null;
      this.request?.abort();
      this.observer?.disconnect();
      clearTimeout(this.cartTimer);
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.scrollFrame);
      for (const state of this.states?.values() || []) { clearTimeout(state.timer); state.animation?.cancel(); }
      this.group?.style.removeProperty(this.offsetProperty);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-hero-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-hero-banner')) {
  customElements.define('auro-hero-banner', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.root = this.closest('.auro-hero');
      if (!this.root) return;
      this.seen = this.seen || new WeakSet();
      this.video = this.querySelector('[data-hero-video]');
      this.button = this.querySelector('.auro-hero-video-button');
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.inView = false;
      this.intent = null;
      this.failed = false;
      this.playPending = false;
      this.mediaGeneration = (this.mediaGeneration || 0) + 1;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.onViewport = () => this.evaluate();
      this.onMotion = () => {
        if (this.motion.matches && this.intent !== 'pause') this.intent = null;
        this.observe();
        this.evaluate();
      };
      this.mobile.addEventListener('change', this.onViewport);
      this.motion.addEventListener('change', this.onMotion);
      this.connection?.addEventListener?.('change', this.onViewport);
      document.addEventListener('visibilitychange', this.onViewport, { signal });
      this.button?.addEventListener('click', () => {
        this.intent = this.video.paused ? 'play' : 'pause';
        this.failed = false;
        this.evaluate();
      }, { signal });
      this.video?.addEventListener('play', () => {
        if (!this.wantsPlayback()) { this.video.pause(); return; }
        this.root.classList.add('auro-hero--video-ready');
        this.sync();
      }, { signal });
      this.video?.addEventListener('pause', () => this.sync(), { signal });
      this.video?.addEventListener('ended', () => { this.intent = 'pause'; this.sync(); }, { signal });
      this.video?.addEventListener('error', () => {
        this.failed = true;
        this.root.classList.remove('auro-hero--video-ready');
        this.video.pause();
        this.sync();
      }, { signal });
      this.addEventListener('shopify:block:select', (event) => {
        const node = event.target.closest?.('.auro-hero-button-wrap');
        if (node && this.contains(node) && !this.motion.matches && this.root.hasAttribute('data-animate')) this.reveal(node, 0);
      }, { signal });
      this.observe();
      this.sync();
    }
    observe() {
      this.observer?.disconnect();
      if (typeof IntersectionObserver === 'undefined') {
        const bounds = this.root.getBoundingClientRect();
        this.inView = bounds.top < window.innerHeight && bounds.bottom > 0;
        this.evaluate();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (!this.isConnected) return;
        let index = 0;
        for (const entry of entries) {
          if (entry.target === this.root) {
            this.inView = entry.isIntersecting;
            this.evaluate();
          } else if (entry.isIntersecting && !this.motion.matches) {
            const stagger = Math.max(0, Math.min(160, Number(this.dataset.stagger) || 0));
            this.reveal(entry.target, Math.min(index++, 5) * stagger);
            this.observer.unobserve(entry.target);
          }
        }
      }, { threshold: 0 });
      if (this.video) this.observer.observe(this.root);
      if (this.root.hasAttribute('data-animate') && !this.motion.matches) {
        this.querySelectorAll('.auro-hero-content > :not(.auro-hero-buttons), .auro-hero-button-wrap').forEach((node) => {
          if (!this.seen.has(node)) this.observer.observe(node);
        });
      }
    }
    reveal(node, delay) {
      if (this.seen.has(node)) return;
      this.seen.add(node);
      node.style.setProperty('--hero-enter-delay', `${delay}ms`);
      node.classList.add('is-entering');
    }
    wantsPlayback() {
      if (!this.video || !this.isConnected || !this.inView || document.hidden || this.failed) return false;
      if (this.mobile.matches && this.video.hasAttribute('data-desktop-only')) return false;
      if (this.intent === 'pause') return false;
      return this.intent === 'play' || (this.video.dataset.autoplay === 'true' && !this.motion.matches && !this.connection?.saveData);
    }
    evaluate() {
      if (!this.video) return;
      if (this.mobile.matches && this.video.hasAttribute('data-desktop-only')) {
        this.video.pause();
        if (this.video.getAttribute('src')) {
          this.mediaGeneration++;
          this.playPending = false;
          this.video.removeAttribute('src');
          this.video.load();
        }
        this.root.classList.remove('auro-hero--video-ready');
        this.sync();
        return;
      }
      const desired = this.mobile.matches ? (this.video.dataset.mobileSrc || this.video.dataset.desktopSrc) : this.video.dataset.desktopSrc;
      if (this.video.getAttribute('src') && this.video.getAttribute('src') !== desired) {
        this.mediaGeneration++;
        this.playPending = false;
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        this.failed = false;
        this.root.classList.remove('auro-hero--video-ready');
      }
      if (!this.wantsPlayback()) { this.video.pause(); this.sync(); return; }
      if (!desired) return;
      if (this.video.getAttribute('src') !== desired) {
        this.video.src = desired;
        this.video.preload = 'metadata';
        this.video.load();
      } else if (this.video.error) this.video.load();
      if (!this.video.paused || this.playPending) return;
      this.video.muted = true;
      this.playPending = true;
      const generation = this.mediaGeneration;
      const video = this.video;
      try {
        Promise.resolve(this.video.play()).then(() => {
          if (generation !== this.mediaGeneration) return;
          if (!this.wantsPlayback()) video.pause();
        }).catch(() => {
          if (generation !== this.mediaGeneration) return;
          this.failed = true;
          this.root.classList.remove('auro-hero--video-ready');
          video.pause();
        }).finally(() => {
          if (generation !== this.mediaGeneration) return;
          this.playPending = false;
          this.sync();
        });
      } catch (_) {
        this.playPending = false;
        this.failed = true;
        this.root.classList.remove('auro-hero--video-ready');
        this.video.pause();
        this.sync();
      }
    }
    sync() {
      if (!this.video || !this.button) return;
      const paused = this.video.paused;
      this.button.setAttribute('aria-pressed', String(paused));
      this.button.setAttribute('aria-label', paused ? this.button.dataset.labelPlay : this.button.dataset.labelPause);
    }
    disconnectedCallback() {
      this.mediaGeneration = (this.mediaGeneration || 0) + 1;
      this.observer?.disconnect();
      this.events?.abort();
      if (this.mobile && this.onViewport) this.mobile.removeEventListener('change', this.onViewport);
      if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
      this.connection?.removeEventListener?.('change', this.onViewport);
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-ingredients-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-ingredients-page-v3')) {
  customElements.define('auro-ingredients-page-v3', class extends HTMLElement {
    static viewStates = new Map();
    connectedCallback() { queueMicrotask(() => this.initialize()); }

    initialize() {
      if (!this.isConnected || this.abort) return;
      this.abort = new AbortController();
      this.alive = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.explorers = [];
      this.animations = new Set();
      this.elementAnimations = new WeakMap();
      const signal = this.abort.signal;
      const listen = (target, event, fn, options = {}) => target?.addEventListener(event, fn, { ...options, signal });
      for (const root of this.querySelectorAll('[data-explorer]')) {
        const state = { root, tabs: [...root.querySelectorAll('[data-tab]')], panels: [...root.querySelectorAll('[data-panel]')], categories: new Map(), active: null };
        state.tabs.forEach(tab => {
          tab.setAttribute('role', 'tab');
          const panel = state.panels.find(panel => panel.dataset.panel === tab.dataset.tab);
          if (!panel?.querySelector('[data-ingredient]')) { tab.hidden = true; return; }
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          listen(tab, 'click', () => this.selectProduct(state, tab.dataset.tab));
          listen(tab, 'keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const available = state.tabs.filter(tab => !tab.hidden);
            const index = available.indexOf(tab);
            const direction = getComputedStyle(root).direction === 'rtl' ? -1 : 1;
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? available.length - 1 : (index + (event.key === 'ArrowRight' ? direction : -direction) + available.length) % available.length;
            this.selectProduct(state, available[next].dataset.tab);
            available[next].focus();
          });
        });
        const tabs = root.querySelector('[data-tabs]');
        tabs.setAttribute('role', 'tablist');
        tabs.hidden = false;
        for (const panel of state.panels) {
          panel.querySelector('[data-filters]').hidden = false;
          for (const button of panel.querySelectorAll('[data-filter]')) listen(button, 'click', () => this.selectCategory(state, panel.dataset.panel, button.dataset.filter));
        }
        this.explorers.push(state);
        const first = state.tabs.find(tab => !tab.hidden && tab.dataset.tab === root.dataset.default) || state.tabs.find(tab => !tab.hidden);
        const savedView = this.constructor.viewStates.get(this.id);
        if (savedView) state.categories = new Map(savedView.categories);
        const initial = savedView && state.tabs.find(tab => !tab.hidden && tab.dataset.tab === savedView.profile) || first;
        if (initial) this.selectProduct(state, initial.dataset.tab, false);
      }
      this.dataset.enhanced = '';
      this.dialog = this.querySelector('[data-dialog]');
      this.dialogContent = this.querySelector('[data-dialog-content]');
      if (this.dialog && typeof this.dialog.showModal === 'function') {
        for (const details of this.querySelectorAll('[data-detail]')) {
          const summary = details.querySelector('summary');
          summary.setAttribute('aria-haspopup', 'dialog');
          listen(summary, 'click', event => {
            event.preventDefault();
            this.openDetail(details, summary);
          });
        }
        listen(this.querySelector('[data-dialog-close]'), 'click', () => this.closeDetail());
        listen(this.dialog, 'cancel', event => { event.preventDefault(); this.closeDetail(); });
        listen(this.dialog, 'click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDetail();
        });
        listen(this.dialog, 'close', () => this.releaseDialog());
      }
      for (const faq of this.querySelectorAll('[data-faq]')) listen(faq, 'toggle', () => {
        if (faq.open) this.animateElement(faq.querySelector('.aip-faq-answer'));
      });
      listen(this.motion, 'change', () => {
        if (!this.motion.matches) return;
        this.observer?.disconnect();
        for (const animation of this.animations) animation.cancel();
        this.animations.clear();
        this.querySelectorAll('.aip-enter').forEach(el => el.classList.remove('aip-enter'));
        if (this.closing) this.closeDetail(true);
      });
      listen(document, 'shopify:block:select', event => {
        if (event.detail?.sectionId !== this.id.replace('AuroIngredientsPage-', '')) return;
        const id = event.detail?.blockId;
        for (const state of this.explorers) {
          const editor = [...this.querySelectorAll('[data-library-editor]')].find(editor => editor.dataset.libraryEditor === id);
          const card = [...state.root.querySelectorAll('[data-ingredient]')].find(card => card.dataset.ingredient === id || editor && card.dataset.library === id && card.dataset.slot === editor.dataset.editItem);
          if (!card) continue;
          const profile = card.closest('[data-panel]').dataset.panel;
          this.selectProduct(state, profile, false);
          this.selectCategory(state, profile, 'all', false);
          card.scrollIntoView({ block: 'nearest', behavior: this.canAnimate() ? 'smooth' : 'auto' });
        }
      });
      if (this.canAnimate() && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('aip-enter');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: .08 });
        this.querySelectorAll('[data-enter]').forEach(el => this.observer.observe(el));
      }
    }

    canAnimate() { return this.dataset.motion === 'true' && !this.motion.matches; }

    animateElement(element, exit = false) {
      if (!element || !this.canAnimate() || !element.animate) return null;
      this.elementAnimations?.get(element)?.cancel();
      const frames = exit ? [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(6px)' }] : [{ opacity: .25, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }];
      const animation = element.animate(frames, { duration: exit ? 160 : 280, easing: 'cubic-bezier(.22,1,.36,1)' });
      this.animations.add(animation);
      this.elementAnimations?.set(element, animation);
      animation.finished.catch(() => {}).finally(() => {
        this.animations.delete(animation);
        if (this.elementAnimations?.get(element) === animation) this.elementAnimations.delete(element);
      });
      return animation;
    }

    selectProduct(state, profile, animate = true) {
      const selected = state.panels.find(panel => panel.dataset.panel === profile);
      if (!selected) return;
      state.active = profile;
      state.tabs.forEach(tab => {
        const active = tab.dataset.tab === profile;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      state.panels.forEach(panel => { panel.hidden = panel !== selected; });
      this.selectCategory(state, profile, state.categories.get(profile) || 'all', false);
      if (animate) this.animateElement(selected);
    }

    selectCategory(state, profile, category, animate = true) {
      const panel = state.panels.find(panel => panel.dataset.panel === profile);
      if (!panel) return;
      const buttons = [...panel.querySelectorAll('[data-filter]')];
      if (!buttons.some(button => button.dataset.filter === category)) category = 'all';
      state.categories.set(profile, category);
      this.constructor.viewStates.set(this.id, { profile: state.active, categories: [...state.categories] });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
      let count = 0;
      panel.querySelectorAll('[data-category]').forEach(group => {
        group.hidden = category !== 'all' && group.dataset.category !== category;
        if (!group.hidden) count += group.querySelectorAll('[data-ingredient]').length;
      });
      const status = state.root.querySelector('[data-filter-status]');
      const filter = buttons.find(button => button.dataset.filter === category);
      if (status) status.textContent = `${panel.dataset.label}: ${count} ${status.dataset.countLabel} · ${filter?.textContent.trim() || ''}`;
      if (animate) this.animateElement(panel);
    }

    openDetail(details, trigger) {
      if (!this.dialog || !this.dialogContent) return;
      this.dialogAnimation?.cancel();
      this.closing = false;
      const source = details.querySelector('[data-detail-content]');
      const content = document.createDocumentFragment();
      for (const child of source.children) content.appendChild(child.cloneNode(true));
      this.dialogContent.replaceChildren(content);
      const title = this.dialogContent.querySelector('h3');
      title.id = this.dialog.getAttribute('aria-labelledby');
      this.trigger = trigger;
      if (!this.dialog.open) {
        this.savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.ownsScroll = true;
        this.dialog.showModal();
      }
      this.dialog.scrollTop = 0;
      this.dialogAnimation = this.animateElement(this.dialog.querySelector('.aip-dialog-box'));
      this.querySelector('[data-dialog-close]').focus({ preventScroll: true });
    }

    closeDetail(immediate = false) {
      if (!this.dialog?.open || this.closing && !immediate) return;
      this.dialogAnimation?.cancel();
      this.closing = true;
      const finish = () => { this.closing = false; this.dialog.close(); this.releaseDialog(); };
      if (!immediate) {
        const animation = this.animateElement(this.dialog.querySelector('.aip-dialog-box'), true);
        this.dialogAnimation = animation;
        if (animation) { animation.finished.then(() => { if (this.dialogAnimation === animation) finish(); }).catch(() => {}); return; }
      }
      finish();
    }

    releaseDialog() {
      if (this.ownsScroll) { document.documentElement.style.overflow = this.savedOverflow; this.ownsScroll = false; }
      if (this.trigger?.isConnected && !this.trigger.closest('[hidden]')) this.trigger.focus({ preventScroll: true });
      this.trigger = null;
    }

    disconnectedCallback() {
      this.alive = false;
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      for (const animation of this.animations || []) animation.cancel();
      this.animations?.clear();
      this.trigger = null;
      this.closeDetail(true);
      this.releaseDialog();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-product-buybox"] && !Shopify.designMode) return;
  try {
    


if (!customElements.get('auro-product-buybox')) {
  customElements.define('auro-product-buybox', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const listen = (type, handler, options = {}) => this.addEventListener(type, handler, {...options, signal:this.abort.signal});
      this.select = this.querySelector('[data-variant-select]');
      this.quantity = this.querySelector('[data-quantity]');
      this.atc = this.querySelector('[data-atc]');
      this.items = Array.from(this.querySelectorAll('.ap-gallery-item[data-index]'));
      this.index = 0;
      this.dialog = this.querySelector('.ap-zoom-dialog');
      this.main = this.querySelector('.ap-main-content');
      this.savedVariants = {};
      this.ignoreZoomClickUntil = 0;
      this.touchStart = null;
      this.zoomTouchStart = null;
      this.galleryImageIndices = this.items.map((item, i) => item.querySelector('template')?.content.querySelector('[data-zoom]') ? i : -1).filter(i => i >= 0);
      if (this.select && this.select.selectedOptions[0]) this.updateVariant(this.select.selectedOptions[0]);
      this.querySelectorAll('.ap-offer-radio').forEach(radio => {
        radio.disabled = !this.select || !Array.from(this.select.options).some(o => o.dataset.offer === radio.value && o.dataset.allowed === 'true');
      });
      this.querySelectorAll('.ap-thumbnail').forEach(button => button.disabled = false);
      const controls = this.querySelector('.ap-gallery-controls');
      if (controls) controls.hidden = this.items.length < 2;
      const nav = this.querySelector('.ap-side-nav');
      if (nav) nav.hidden = this.items.length < 2;
      listen('change', event => {
        if (event.target.matches('.ap-offer-radio')) this.chooseOffer(event.target.value);
        if (event.target === this.select) this.updateVariant(this.select.selectedOptions[0]);
      });
      listen('click', event => {
        const thumb = event.target.closest('[data-show-media]');
        if (thumb) { this.showMedia(Number(thumb.dataset.showMedia)); return; }
        if (event.target.closest('[data-gallery-prev]')) { this.showMedia(this.index - 1); return; }
        if (event.target.closest('[data-gallery-next]')) { this.showMedia(this.index + 1); return; }
        if (event.target.closest('[data-close-zoom]')) { this.dialog?.close(); return; }
        if (event.target.closest('[data-zoom-prev]')) { this.navigateZoom(-1); return; }
        if (event.target.closest('[data-zoom-next]')) { this.navigateZoom(1); return; }
        const zoom = event.target.closest('[data-zoom]');
        if (zoom) {
          if (Date.now() < this.ignoreZoomClickUntil) { event.preventDefault(); return; }
          const tile = zoom.closest('.ap-gallery-item[data-index]');
          this.zoomOpener = zoom;
          if (this.openZoom(tile ? Number(tile.dataset.index) : this.index)) event.preventDefault();
          return;
        }
        if (event.target === this.dialog) this.dialog?.close();
      });
      listen('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (this.dialog?.open && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
          event.preventDefault();
          this.navigateZoom((event.key === 'ArrowRight' ? 1 : -1) * (this.isRtl() ? -1 : 1));
          return;
        }
        if (event.target.matches('.ap-main-media') && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
          event.preventDefault();
          this.showMedia(this.index + ((event.key === 'ArrowRight' ? 1 : -1) * (this.isRtl() ? -1 : 1)));
        }
      });
      listen('touchstart', event => {
        if (event.touches.length !== 1) { this.touchStart = null; this.zoomTouchStart = null; return; }
        if (event.target.closest('video, iframe, model-viewer, button, input, select, textarea')) return;
        const p = {x:event.touches[0].clientX, y:event.touches[0].clientY};
        if (this.dialog?.open && event.target.closest('.ap-zoom-stage')) this.zoomTouchStart = p;
        else if (event.target.closest('.ap-main-media') && !event.target.closest('button')) this.touchStart = p;
      }, {passive:true});
      listen('touchend', event => {
        if (event.touches?.length) { this.touchStart = null; this.zoomTouchStart = null; return; }
        if (!event.changedTouches.length) return;
        if (this.zoomTouchStart) {
          const dx = event.changedTouches[0].clientX - this.zoomTouchStart.x;
          const dy = event.changedTouches[0].clientY - this.zoomTouchStart.y;
          this.zoomTouchStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) this.navigateZoom((dx < 0 ? 1 : -1) * (this.isRtl() ? -1 : 1));
          return;
        }
        if (this.touchStart) {
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.ignoreZoomClickUntil = Date.now() + 500;
            this.showMedia(this.index + ((dx < 0 ? 1 : -1) * (this.isRtl() ? -1 : 1)));
          }
        }
      }, {passive:true});
      listen('touchcancel', () => { this.touchStart = null; this.zoomTouchStart = null; }, {passive:true});
      listen('submit', event => {
        if (!event.target.matches('.ap-product-form')) return;
        const option = this.select?.selectedOptions[0];
        if (!option || option.dataset.allowed !== 'true') {
          event.preventDefault();
          const status = this.querySelector('[data-form-status]');
          if (status) { status.textContent = this.stateLabel(option); status.hidden = false; }
        }
      });
      listen('shopify:block:select', event => {
        const details = event.target.closest('.ap-accordion');
        if (details && this.contains(details)) details.open = true;
        const item = event.target.closest('.ap-gallery-item');
        if (item) this.showMedia(Number(item.dataset.index));
      });
      this.dialog?.addEventListener('close', () => {
        this.touchStart = null;
        this.zoomTouchStart = null;
        const target = this.zoomReturnFocus?.isConnected ? this.zoomReturnFocus : this.querySelector('.ap-main-media');
        target?.focus({preventScroll:true});
        this.zoomReturnFocus = null;
        this.zoomOpener = null;
      }, {signal:this.abort.signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, {signal:this.abort.signal});
      this.info = this.querySelector('.ap-info-sticky');
      if (this.info && 'ResizeObserver' in window) {
        this.stickyObserver = new ResizeObserver(() => this.updateSticky());
        this.stickyObserver.observe(this.info);
      }
      window.addEventListener('resize', () => this.updateSticky(), {signal:this.abort.signal});
      this.updateDelivery();
      if (this.dataset.purchaseMode === 'kaching') this.connectBundlePrice();
      this.setAttribute('data-ready', '');
      this.updateSticky();
      this.scrollActiveThumbnail();
    }
    isRtl() {
      return getComputedStyle(this).direction === 'rtl';
    }
    updateSticky() {
      if (!this.info) return;
      const offset = parseFloat(getComputedStyle(this).getPropertyValue('--ap-sticky')) || 0;
      this.info.toggleAttribute('data-sticky-disabled', window.innerWidth < 1000 || this.info.offsetHeight > window.innerHeight - offset - 24);
    }
    scrollActiveThumbnail() {
      cancelAnimationFrame(this.thumbnailFrame);
      this.thumbnailFrame = requestAnimationFrame(() => {
        const track = this.querySelector('.ap-gallery-grid');
        const item = this.items[this.index];
        if (!track || !item || !getComputedStyle(track).gridAutoFlow.includes('column')) return;
        const bounds = track.getBoundingClientRect();
        const rect = item.getBoundingClientRect();
        const delta = rect.left < bounds.left ? rect.left - bounds.left : rect.right > bounds.right ? rect.right - bounds.right : 0;
        if (Math.abs(delta) > 1) track.scrollTo({left:track.scrollLeft + delta, behavior:this.motion.matches ? 'auto' : 'smooth'});
      });
    }
    connectBundlePrice() {
      this.bundleWidgets = new WeakSet();
      this.bundleDetail = null;
      const bind = () => this.querySelectorAll('kaching-bundles-block, kaching-bundle').forEach(widget => {
        if (this.bundleWidgets.has(widget)) return;
        this.bundleWidgets.add(widget);
        ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach(type => {
          widget.addEventListener(type, event => {
            this.bundleDetail = type === 'variants-changed' ? event.detail : null;
            this.queueBundlePrice();
          }, {signal:this.abort.signal});
        });
      });
      const selected = event => {
        if (event.target.closest('kaching-bundles-block, kaching-bundle, .kaching-bundles')) {
          this.bundleDetail = null;
          this.queueBundlePrice();
        }
      };
      this.addEventListener('click', selected, {signal:this.abort.signal, capture:true});
      this.addEventListener('change', selected, {signal:this.abort.signal, capture:true});
      this.bundleObserver = new MutationObserver(records => {
        bind();
        if (records.some(record => {
          const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          return target?.closest('kaching-bundles-block, kaching-bundle, .kaching-bundles, [data-atc-price]') || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('kaching-bundles-block, kaching-bundle, .kaching-bundles') || node.querySelector('kaching-bundles-block, kaching-bundle, .kaching-bundles')));
        })) this.queueBundlePrice();
      });
      this.bundleObserver.observe(this, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class', 'checked', 'aria-checked']});
      bind();
      this.queueBundlePrice();
    }
    queueBundlePrice() {
      if (this.bundleFrame) cancelAnimationFrame(this.bundleFrame);
      this.bundleFrame = requestAnimationFrame(() => {
        this.bundleFrame = null;
        this.syncBundlePrice();
      });
    }
    syncBundlePrice() {
      if (this.dataset.purchaseMode !== 'kaching') return;
      const price = this.querySelector('[data-main-price]');
      if (!price) return;
      const checked = this.querySelector('.kaching-bundles input[type="radio"]:checked');
      const card = checked?.closest('.kaching-bundles__bar') || this.querySelector('.kaching-bundles__bar--selected');
      const read = node => node?.textContent.replace(/\s+/g, ' ').trim() || '';
      const detail = this.bundleDetail;
      const candidates = [detail?.formattedPrice, detail?.priceFormatted, detail?.totalPriceFormatted, detail?.price?.formatted, detail?.price];
      const formatted = candidates.find(value => typeof value === 'string' && /\d/.test(value) && /[^\d\s.,]/.test(value));
      let total = formatted || read(card?.querySelector('.kaching-bundles__bar-price'));
      if (!total && this.querySelector('kaching-bundles-block, kaching-bundle, .kaching-bundles')) total = read(this.atc?.querySelector('[data-atc-price]')).replace(/^[·\s]+/, '');
      if (!total) return;
      const was = this.querySelector('[data-main-was]');
      const compare = formatted ? '' : read(card?.querySelector('.kaching-bundles__bar-full-price'));
      if (was) {
        was.hidden = !compare || compare === total;
        if (was.textContent !== compare) was.textContent = compare;
      }
      const percent = this.querySelector('[data-main-percent]');
      if (percent) percent.hidden = true;
      if (price.textContent === total) return;
      price.textContent = total;
      const row = this.querySelector('.ap-main-price');
      if (row) {
        row.classList.remove('ap-price-changing');
        void row.offsetWidth;
        row.classList.add('ap-price-changing');
      }
    }
    stateLabel(option) {
      if (!option || option.dataset.pending === 'true') return this.dataset.pendingLabel;
      if (option.dataset.planRequired === 'true') return this.dataset.planLabel;
      return this.dataset.soldOutLabel;
    }
    chooseOffer(offer) {
      const options = Array.from(this.select.options).filter(o => o.dataset.offer === offer);
      const chosen = options.find(o => o.value === this.savedVariants[offer]) || options.find(o => o.dataset.allowed === 'true') || options[0];
      if (!chosen) return;
      this.select.value = chosen.value;
      this.updateVariant(chosen);
    }
    updateVariant(option) {
      if (!option) return;
      if (this.dataset.purchaseMode === 'kaching') {
        const allowed = option.dataset.allowed === 'true';
        const wasDisabled = this.atc.disabled;
        this.atc.disabled = !allowed;
        if (!allowed) this.atc.querySelector('[data-atc-label]').textContent = this.stateLabel(option);
        else if (wasDisabled) {
          this.atc.querySelector('[data-atc-label]').textContent = this.dataset.addLabel;
          const price = this.atc.querySelector('[data-atc-price]');
          price.hidden = false;
          price.textContent = `· ${option.dataset.price}`;
        }
        const stock = this.querySelector('[data-stock-row]');
        if (stock) stock.hidden = option.dataset.stock !== 'true';
        return;
      }
      const offer = option.dataset.offer;
      this.savedVariants[offer] = option.value;
      Array.from(this.select.options).forEach(o => {
        o.hidden = o.dataset.offer !== offer;
        o.disabled = o.dataset.allowed !== 'true' || o.dataset.offer !== offer;
      });
      this.querySelectorAll('.ap-offer-radio').forEach(radio => radio.checked = radio.value === offer);
      this.querySelectorAll('[data-offer-card]').forEach(card => card.classList.toggle('is-selected', card.dataset.offerCard === offer));
      const pending = option.dataset.pending === 'true';
      const allowed = option.dataset.allowed === 'true';
      this.atc.disabled = !allowed;
      this.atc.querySelector('[data-atc-label]').textContent = allowed ? this.dataset.addLabel : this.stateLabel(option);
      const price = this.atc.querySelector('[data-atc-price]');
      price.hidden = !allowed;
      price.textContent = `· ${option.dataset.price}`;
      const saving = this.atc.querySelector('[data-atc-saving]');
      saving.hidden = !allowed || !option.dataset.saving;
      saving.textContent = option.dataset.saving;
      this.querySelector('[data-main-price]').textContent = pending ? this.dataset.pendingLabel : option.dataset.price;
      const was = this.querySelector('[data-main-was]');
      was.hidden = pending || !option.dataset.was;
      was.textContent = option.dataset.was;
      const percent = this.querySelector('[data-main-percent]');
      percent.hidden = pending || Number(option.dataset.percent) <= 0;
      percent.textContent = `${this.dataset.saveLabel} ${option.dataset.percent}%`;
      const mainPrice = this.querySelector('.ap-main-price');
      if (mainPrice) { mainPrice.classList.remove('ap-price-changing'); void mainPrice.offsetWidth; mainPrice.classList.add('ap-price-changing'); }
      const stock = this.querySelector('[data-stock-row]');
      if (stock) stock.hidden = option.dataset.stock !== 'true';
      this.select.closest('.ap-variant-row').hidden = true;
      const minimum = Number(option.dataset.min) || 1;
      const step = Number(option.dataset.step) || 1;
      this.quantity.min = String(minimum);
      this.quantity.step = String(step);
      if (option.dataset.max) this.quantity.max = option.dataset.max; else this.quantity.removeAttribute('max');
      this.quantity.value = String(minimum);
      this.quantity.closest('.ap-quantity-row').hidden = this.dataset.quantityOptional !== 'true' && minimum === 1;
      const status = this.querySelector('[data-form-status]');
      if (status) status.hidden = true;
      if (option.dataset.mediaId) {
        const index = this.items.findIndex(item => item.dataset.mediaId === option.dataset.mediaId);
        if (index >= 0) this.showMedia(index);
      }
    }
    updateDelivery() {
      const row = this.querySelector('[data-delivery]');
      if (!row) return;
      const today = new Date();
      let formatter;
      try { formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short',day:'numeric'}); }
      catch { formatter = new Intl.DateTimeFormat('en', {month:'short',day:'numeric'}); }
      const format = date => formatter.format(date);
      const addDays = offset => {
        const date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 12);
        let remaining = Math.max(0, Number(offset) || 0);
        while (remaining > 0) {
          date.setDate(date.getDate() + 1);
          if (row.dataset.businessDays !== 'true' || (date.getDay() !== 0 && date.getDay() !== 6)) remaining--;
        }
        return date;
      };
      const dispatch = Math.max(0, Number(row.dataset.dispatchDays) || 0);
      const minimum = Math.max(dispatch, Number(row.dataset.deliveryMin) || 0);
      const maximum = Math.max(minimum, Number(row.dataset.deliveryMax) || 0);
      row.querySelector('[data-delivery-date="ordered"]').textContent = format(today);
      row.querySelector('[data-delivery-date="dispatched"]').textContent = format(addDays(dispatch));
      row.querySelector('[data-delivery-date="delivered"]').textContent = minimum === maximum ? format(addDays(minimum)) : `${format(addDays(minimum))}–${format(addDays(maximum))}`;
    }
    openZoom(index) {
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || !this.galleryImageIndices.length) return false;
      const idx = this.galleryImageIndices.includes(index) ? index : this.galleryImageIndices[0];
      if (!this.dialog.open) this.zoomReturnFocus = this.zoomOpener || document.activeElement;
      this.showMedia(idx);
      this.updateZoomImage();
      if (!this.dialog.open) this.dialog.showModal();
      return true;
    }
    updateZoomImage() {
      const source = this.items[this.index]?.querySelector('template')?.content.querySelector('[data-zoom]');
      const img = this.dialog?.querySelector('.ap-zoom-image');
      if (!source || !img) return;
      img.src = source.href;
      img.alt = source.querySelector('img')?.alt || '';
      img.classList.remove('ap-zoom-changing');
      void img.offsetWidth;
      img.classList.add('ap-zoom-changing');
      const count = this.dialog.querySelector('[data-zoom-counter]');
      if (count) count.textContent = `${this.galleryImageIndices.indexOf(this.index) + 1} / ${this.galleryImageIndices.length}`;
      const canMove = this.galleryImageIndices.length > 1;
      this.dialog.querySelectorAll('.ap-zoom-nav').forEach(btn => btn.hidden = !canMove);
    }
    navigateZoom(direction) {
      if (!this.dialog?.open || !this.galleryImageIndices.length) return;
      const position = this.galleryImageIndices.indexOf(this.index);
      const next = this.galleryImageIndices[(position + direction + this.galleryImageIndices.length) % this.galleryImageIndices.length];
      if (next == null) return;
      this.showMedia(next);
      this.updateZoomImage();
    }
    showMedia(index) {
      if (!this.items.length || !this.main || !Number.isFinite(index)) return;
      const next = ((Math.trunc(index) % this.items.length) + this.items.length) % this.items.length;
      const source = this.items[next].querySelector('template');
      if (!source?.content) return;
      const changed = next !== this.index || !this.main.firstElementChild;
      this.index = next;
      if (changed) {
        this.querySelectorAll('video').forEach(video => video.pause());
        this.main.replaceChildren(source.content.cloneNode(true));
        if (!this.motion.matches) {
          this.main.classList.remove('ap-switching');
          void this.main.offsetWidth;
          this.main.classList.add('ap-switching');
        }
      }
      this.querySelectorAll('[data-show-media]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.showMedia) === this.index)));
      const counter = this.querySelector('[data-counter]');
      const text = `${this.index + 1} / ${this.items.length}`;
      if (counter && counter.textContent !== text) counter.textContent = text;
      this.scrollActiveThumbnail();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.stickyObserver?.disconnect();
      cancelAnimationFrame(this.thumbnailFrame);
      this.bundleObserver?.disconnect();
      if (this.bundleFrame) cancelAnimationFrame(this.bundleFrame);
      this.querySelectorAll('video').forEach(video => video.pause());
      if (this.dialog?.open) this.dialog.close();
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-product-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-product-cards')) {
  customElements.define('auro-product-cards', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.abort) this.setup(); });
    }
    setup() {
      this.grid = this.querySelector('.apc__grid');
      if (!this.grid) return;
      this.root = this.closest('.apc');
      this.cards = Array.from(this.grid.querySelectorAll('.apc__card'));
      this.nav = this.querySelector('.apc__navigation');
      this.dots = Array.from(this.querySelectorAll('[data-slide]'));
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.active = 0;
      this.animations = new Set();
      const signal = this.abort.signal;
      this.grid.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
      this.grid.addEventListener('keydown', event => {
        if (event.target !== this.grid || !this.carousel) return;
        const rtl = getComputedStyle(this.grid).direction === 'rtl';
        let target;
        if (event.key === 'ArrowRight') target = this.active + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') target = this.active + (rtl ? 1 : -1);
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.cards.length - 1;
        if (target !== undefined) { event.preventDefault(); this.go(target); }
      }, { signal });
      this.nav?.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        this.go(button.hasAttribute('data-slide') ? Number(button.dataset.slide) : this.active + Number(button.dataset.step));
      }, { signal });
      this.mobile.addEventListener('change', () => this.schedule(), { signal });
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.animations.forEach(animation => animation.cancel());
        this.updateVideos();
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest?.('.apc__card');
        if (card && this.contains(card) && this.carousel) this.go(this.cards.indexOf(card), true);
      }, { signal });
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.schedule());
        this.resize.observe(this.grid);
      } else window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
      this.setupMotion();
      this.setupVideos(signal);
      this.schedule();
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
    }
    update() {
      const max = this.grid.scrollWidth - this.grid.clientWidth;
      this.carousel = this.mobile.matches && this.root.dataset.mobileLayout === 'carousel' && max > 2;
      if (this.nav) this.nav.hidden = !this.carousel;
      if (this.carousel) this.grid.setAttribute('tabindex', '0');
      else this.grid.removeAttribute('tabindex');
      if (!this.carousel) return;
      const viewport = this.grid.getBoundingClientRect();
      const offset = Math.abs(this.grid.scrollLeft);
      let best = -1;
      this.cards.forEach((card, index) => {
        const box = card.getBoundingClientRect();
        const visible = Math.max(0, Math.min(box.right, viewport.right) - Math.max(box.left, viewport.left));
        const ratio = visible / Math.max(1, box.width);
        if (ratio > best + .001) { best = ratio; this.active = index; }
      });
      if (offset <= 2) this.active = 0;
      if (offset >= max - 2) this.active = this.cards.length - 1;
      this.dots.forEach((dot, index) => {
        if (index === this.active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      const previous = this.nav?.querySelector('[data-step="-1"]');
      const next = this.nav?.querySelector('[data-step="1"]');
      if (previous) previous.disabled = offset <= 2;
      if (next) next.disabled = offset >= max - 2;
    }
    go(index, instant = false) {
      const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!card) return;
      const viewport = this.grid.getBoundingClientRect();
      const box = card.getBoundingClientRect();
      const rtl = getComputedStyle(this.grid).direction === 'rtl';
      this.grid.scrollBy({ left: rtl ? box.right - viewport.right : box.left - viewport.left, behavior: instant || this.motion.matches ? 'instant' : 'smooth' });
    }
    setupMotion() {
      if (!this.root.hasAttribute('data-animate') || !('IntersectionObserver' in window)) return;
      this.reveal = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          if (!this.motion.matches && entry.target.animate) {
            const animation = entry.target.animate([{ transform: 'translateY(10px)' }, { transform: 'translateY(0)' }], { duration: 480, easing: 'cubic-bezier(.2,.7,.25,1)' });
            this.animations.add(animation);
            animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
          }
          this.reveal.unobserve(entry.target);
        });
      }, { threshold: .12 });
      this.cards.forEach(card => this.reveal.observe(card));
    }
    setupVideos(signal) {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.visibleVideos = new Set();
      this.userPaused = new WeakSet();
      this.expectedPauses = new WeakSet();
      this.videos.forEach(video => {
        video.addEventListener('pause', () => {
          if (this.expectedPauses.has(video)) this.expectedPauses.delete(video);
          else this.userPaused.add(video);
        }, { signal });
        video.addEventListener('play', () => this.userPaused.delete(video), { signal });
      });
      document.addEventListener('visibilitychange', () => this.updateVideos(), { signal });
      if (!('IntersectionObserver' in window)) return;
      this.videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.visibleVideos.add(entry.target);
          else this.visibleVideos.delete(entry.target);
        });
        this.updateVideos();
      }, { threshold: .35 });
      this.videos.forEach(video => this.videoObserver.observe(video));
    }
    updateVideos() {
      this.videos?.forEach(video => {
        const visible = this.visibleVideos.has(video) && !document.hidden;
        if (!visible || this.motion.matches || navigator.connection?.saveData) {
          if (!video.paused) { this.expectedPauses.add(video); video.pause(); }
        } else if (!this.userPaused.has(video)) video.play()?.catch(() => {});
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
      this.reveal?.disconnect();
      this.videoObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.animations?.forEach(animation => animation.cancel());
      this.videos?.forEach(video => video.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-quality-standards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-quality-page-v2')) {
  customElements.define('auro-quality-page-v2', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.seen = this.seen || new WeakSet();
      this.events = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.events.signal;
      this.onMotion = () => this.observeReveals();
      this.motion.addEventListener('change', this.onMotion);
      this.onScroll = () => {
        if (!document.hidden && (this.isWatchingStandards || this.regionIsVisible())) this.queueUpdate();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true, signal });
      document.addEventListener('scroll', this.onScroll, { capture: true, passive: true, signal });
      window.addEventListener('resize', () => this.queueUpdate(), { passive: true, signal });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.queueUpdate();
      }, { signal });
      this.addEventListener('load', () => this.queueUpdate(), { capture: true, signal });
      this.addEventListener('shopify:section:load', () => this.refreshContent(), { signal });
      this.addEventListener('shopify:section:reorder', () => this.queueUpdate(), { signal });
      this.addEventListener('shopify:block:select', (event) => {
        this.refreshContent();
        const standard = event.target.closest?.('[data-standard]');
        if (standard && this.contains(standard)) this.setActive(standard);
        const reveal = event.target.matches?.('[data-reveal]') ? event.target : event.target.querySelector?.('[data-reveal]');
        if (reveal && this.contains(reveal) && this.dataset.motion === 'true' && !this.motion.matches) this.reveal(reveal, 0);
      }, { signal });
      this.refreshContent();
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
        this.resizeObserver.observe(this);
      }
      if (typeof MutationObserver !== 'undefined') {
        this.contentObserver = new MutationObserver((records) => {
          const elementsChanged = records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1));
          if (elementsChanged && this.isConnected) this.refreshContent();
        });
        this.contentObserver.observe(this, { childList: true, subtree: true });
      }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.refreshContent(), { once: true, signal });
      document.fonts?.ready.then(() => { if (this.isConnected) this.queueUpdate(); });
    }
    refreshContent() {
      this.items = Array.from(this.querySelectorAll('[data-standard]'));
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.stage = this.querySelector('[data-stage]');
      this.stageLabel = this.querySelector('[data-stage-label]');
      this.standardsRegion = this.querySelector('[data-standards]');
      this.activeId = null;
      this.isWatchingStandards = this.regionIsVisible();
      this.regionObserver?.disconnect();
      if (this.standardsRegion && typeof IntersectionObserver !== 'undefined') {
        this.regionObserver = new IntersectionObserver((entries) => {
          if (!this.isConnected) return;
          this.isWatchingStandards = entries.some((entry) => entry.isIntersecting);
          if (this.isWatchingStandards) this.queueUpdate();
        }, { threshold: 0 });
        this.regionObserver.observe(this.standardsRegion);
      }
      this.observeReveals();
      this.updateStandard();
      this.queueUpdate();
    }
    viewport() {
      let top = 0;
      let bottom = window.innerHeight || document.documentElement?.clientHeight || 0;
      for (let parent = this.standardsRegion?.parentElement; parent && parent !== document.documentElement; parent = parent.parentElement) {
        const overflow = getComputedStyle(parent).overflowY;
        if (!/(auto|scroll|overlay)/.test(overflow) || parent.scrollHeight <= parent.clientHeight) continue;
        const rect = parent.getBoundingClientRect();
        top = Math.max(top, rect.top + (parent.clientTop || 0));
        bottom = Math.min(bottom, rect.top + (parent.clientTop || 0) + parent.clientHeight);
      }
      return { top, bottom };
    }
    regionIsVisible() {
      if (!this.standardsRegion?.getBoundingClientRect) return false;
      const rect = this.standardsRegion.getBoundingClientRect();
      const view = this.viewport();
      return rect.bottom > view.top && rect.top < view.bottom;
    }
    observeReveals() {
      this.revealObserver?.disconnect();
      if (this.dataset.motion !== 'true' || this.motion.matches || typeof IntersectionObserver === 'undefined') return;
      this.revealObserver = new IntersectionObserver((entries) => {
        if (!this.isConnected || this.motion.matches) return;
        let index = 0;
        const delay = Math.max(0, Math.min(140, Number(this.dataset.stagger) || 0));
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.reveal(entry.target, Math.min(index++, 4) * delay);
          this.revealObserver.unobserve(entry.target);
        }
      }, { threshold: 0, rootMargin: '0px 0px -8px 0px' });
      this.querySelectorAll('[data-reveal]').forEach((node) => {
        if (!this.seen.has(node)) this.revealObserver.observe(node);
      });
    }
    reveal(node, delay) {
      if (this.seen.has(node)) return;
      this.seen.add(node);
      node.style.setProperty('--aqp-enter-delay', `${delay}ms`);
      node.classList.add('is-entering');
    }
    queueUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (this.isConnected) this.updateStandard();
      });
    }
    updateStandard() {
      const desktop = !!this.stage && this.items.length > 0 && getComputedStyle(this.stage).display !== 'none';
      this.dataset.standardsTracking = String(desktop);
      if (!desktop) return;
      const view = this.viewport();
      const activation = Math.max(0.3, Math.min(0.7, (Number(this.standardsRegion?.dataset?.activation) || 50) / 100));
      const target = view.top + (view.bottom - view.top) * activation;
      let active = this.items[0];
      for (const item of this.items) {
        if (item.getBoundingClientRect().top < target) active = item;
      }
      this.setActive(active);
    }
    setActive(active) {
      const id = active.dataset.standard;
      if (id === this.activeId) return;
      this.activeId = id;
      this.items.forEach((item) => item.classList.toggle('is-active', item === active));
      this.slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.slide === id));
      if (this.stageLabel) this.stageLabel.textContent = active.dataset.label || '';
    }
    disconnectedCallback() {
      this.events?.abort();
      this.regionObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.contentObserver?.disconnect();
      if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

if (!customElements.get('auro-report-explorer')) {
  customElements.define('auro-report-explorer', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.entries = Array.from(this.querySelectorAll('[data-report-entry]'));
      this.input = this.querySelector('[data-report-search]');
      this.more = this.querySelector('[data-report-more]');
      this.status = this.querySelector('[data-report-status]');
      this.empty = this.querySelector('[data-report-empty]');
      this.controls = this.querySelector('[data-report-controls]');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.events = new AbortController();
      this.cap = this.initialLimit();
      const signal = this.events.signal;
      this.input?.addEventListener('input', () => {
        this.cap = this.initialLimit();
        this.update();
      }, { signal });
      this.more?.addEventListener('click', () => {
        const firstNew = this.matchesList?.[this.cap];
        this.cap += Math.max(1, Number(this.dataset.batch) || 6);
        this.update();
        const link = firstNew?.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      }, { signal });
      this.onBreakpoint = () => {
        this.cap = this.initialLimit();
        this.update();
      };
      this.mobile.addEventListener('change', this.onBreakpoint);
      this.addEventListener('shopify:block:select', (event) => {
        const row = event.target.closest?.('[data-report-entry]');
        if (!row || !this.contains(row)) return;
        if (this.input) this.input.value = '';
        this.cap = this.entries.length;
        this.update();
      }, { signal });
      if (this.controls) this.controls.hidden = !this.entries.length;
      this.update();
    }
    initialLimit() {
      if (window.Shopify?.designMode || !this.mobile?.matches || this.dataset.paginate !== 'true') return Infinity;
      return Math.max(1, Number(this.dataset.initial) || 6);
    }
    normalized(value) {
      return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }
    update() {
      const query = this.normalized(this.input?.value || '');
      this.matchesList = this.entries.filter((entry) => this.normalized(entry.textContent || '').includes(query));
      const visible = new Set(this.matchesList.slice(0, this.cap));
      this.entries.forEach((entry) => { entry.hidden = !visible.has(entry); });
      if (this.more) this.more.hidden = this.matchesList.length <= this.cap;
      if (this.empty) this.empty.hidden = this.matchesList.length > 0;
      if (this.status) this.status.textContent = `${this.dataset.showing || 'Showing'} ${visible.size} ${this.dataset.of || 'of'} ${this.matchesList.length} ${this.dataset.reports || 'reports'}`;
    }
    disconnectedCallback() {
      this.events?.abort();
      if (this.mobile && this.onBreakpoint) this.mobile.removeEventListener('change', this.onBreakpoint);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-real-routines"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('auro-real-routines')) {
 customElements.define('auro-real-routines', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const signal = this.controller.signal;
   this.videos = [...this.querySelectorAll('video')];
   this.track = this.querySelector('[data-video-track]');
   this.frame = 0;
   this.videos.forEach(video => {
    video.controls = false;
    const media = video.closest('.av-media');
    media.querySelector('[data-play]').hidden = false;
    video.addEventListener('play', () => {
     this.videos.forEach(other => { if (other !== video && !other.paused) other.pause(); });
     video.controls = true;
     media.querySelector('[data-play]').hidden = true;
     media.querySelector('.av-error').hidden = true;
    }, { signal });
    video.addEventListener('ended', () => {
     video.controls = false;
     media.querySelector('[data-play]').hidden = false;
    }, { signal });
    video.addEventListener('error', () => {
     video.controls = true;
     media.querySelector('[data-play]').hidden = true;
     media.querySelector('.av-error').hidden = false;
    }, { signal });
   });
   this.addEventListener('click', event => {
    const play = event.target.closest('[data-play]');
    if (play) {
     const video = play.closest('.av-media').querySelector('video');
     video.controls = true;
     play.hidden = true;
     video.play().then(() => video.focus({ preventScroll: true })).catch(() => {
      video.controls = true;
      play.hidden = false;
     });
     return;
    }
    const next = event.target.closest('[data-next]');
    const previous = event.target.closest('[data-previous]');
    if (next || previous) {
     const card = this.track.querySelector('.av-card');
     if (!card) return;
     const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
     const smooth = this.hasAttribute('data-animate') && !matchMedia('(prefers-reduced-motion: reduce)').matches;
     this.track.scrollBy({ left: step * (next ? 1 : -1), behavior: smooth ? 'smooth' : 'auto' });
    }
   }, { signal });
   this.track.addEventListener('scroll', () => this.schedule(), { signal, passive: true });
   if (typeof ResizeObserver !== 'undefined') {
    this.resizeObserver = new ResizeObserver(() => this.schedule());
    this.resizeObserver.observe(this.track);
   } else window.addEventListener('resize', () => this.schedule(), { signal });
   if (this.hasAttribute('data-pause-offscreen') && typeof IntersectionObserver !== 'undefined') {
    this.visibilityObserver = new IntersectionObserver(entries => entries.forEach(entry => {
     if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
    }), { threshold: 0 });
    this.videos.forEach(video => this.visibilityObserver.observe(video));
   }
   document.addEventListener('visibilitychange', () => {
    if (document.hidden) this.videos.forEach(video => video.pause());
   }, { signal });
   document.addEventListener('shopify:block:select', event => {
    if (!this.contains(event.target)) return;
    const card = event.target.closest('.av-card');
    if (card && this.track.scrollWidth > this.track.clientWidth + 2) card.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
   }, { signal });
   this.schedule();
  }
  schedule() {
   if (this.frame) return;
   this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
  }
  refresh() {
   const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
   const left = Math.max(0, Math.min(max, this.track.scrollLeft));
   this.querySelector('[data-navigation]').hidden = max <= 2;
   this.querySelector('[data-previous]').disabled = left <= 2;
   this.querySelector('[data-next]').disabled = left >= max - 2;
  }
  disconnectedCallback() {
   this.controller?.abort();
   this.controller = null;
   this.resizeObserver?.disconnect();
   this.visibilityObserver?.disconnect();
   this.videos?.forEach(video => { video.pause(); video.controls = true; });
   cancelAnimationFrame(this.frame);
   this.frame = 0;
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-routine-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-reviews-carousel')) {
  class AuroReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-arr-track]');
      if (!this.track || this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.cards = Array.from(this.track.querySelectorAll('[data-arr-card]'));
      this.count = this.querySelector('[data-arr-count]');
      this.prev = this.querySelector('[data-arr-prev]');
      this.next = this.querySelector('[data-arr-next]');
      this.nav = this.querySelector('[data-arr-nav]');
      this.progress = this.querySelector('[data-arr-progress]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.visibleVideos = new Set();
      this.userPaused = new WeakSet();
      this.managedPause = new WeakSet();
      this.pendingIndex = null;
      this.videos = Array.from(this.track.querySelectorAll('video'));
      this.prev?.addEventListener('click', () => this.go(-1), options);
      this.next?.addEventListener('click', () => this.go(1), options);
      this.track.addEventListener('scroll', () => this.onScroll(), { ...options, passive: true });
      this.track.addEventListener('scrollend', () => this.finishScroll(), options);
      this.track.addEventListener('keydown', (event) => this.onKey(event), options);
      this.track.addEventListener('pointerdown', () => this.interrupt(), { ...options, passive: true });
      this.track.addEventListener('wheel', () => this.interrupt(), { ...options, passive: true });
      this.motion.addEventListener('change', () => this.syncVideos(), options);
      this.connection?.addEventListener('change', () => this.syncVideos(), options);
      document.addEventListener('visibilitychange', () => this.syncVideos(), options);
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-arr-card]');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.moveTo(index, 'auto');
      }, options);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.scheduleMeasure());
        this.resizeObserver.observe(this.track);
        this.cards.forEach((card) => this.resizeObserver.observe(card));
      } else {
        window.addEventListener('resize', () => this.scheduleMeasure(), options);
      }
      this.videos.forEach((video) => {
        video.addEventListener('pointerdown', () => this.autoPlaying?.delete(video), options);
        video.addEventListener('keydown', () => this.autoPlaying?.delete(video), options);
        video.addEventListener('pause', () => {
          if (this.managedPause.has(video)) this.managedPause.delete(video);
          else if (!video.ended && this.visibleVideos.has(video) && !document.hidden) this.userPaused.add(video);
        }, options);
        video.addEventListener('play', () => this.userPaused.delete(video), options);
      });
      if (this.videos.length && 'IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
            if (isIntersecting && intersectionRatio >= .4) this.visibleVideos.add(target);
            else {
              this.visibleVideos.delete(target);
              this.pauseVideo(target);
            }
          });
          this.syncVideos();
        }, { threshold: [0, .4] });
        this.videos.forEach((video) => this.videoObserver.observe(video));
      }
      this.measure();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resizeObserver?.disconnect();
      this.videoObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.measureFrame);
      clearTimeout(this.settleTimer);
      this.videos?.forEach((video) => video.pause());
    }

    get position() {
      return Math.min(this.max, Math.max(0, this.rtl ? -this.track.scrollLeft : this.track.scrollLeft));
    }

    measure() {
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = this.position;
      const bounds = this.track.getBoundingClientRect();
      this.positions = this.cards.map((card) => {
        const rect = card.getBoundingClientRect();
        const distance = this.rtl ? bounds.right - rect.right : rect.left - bounds.left;
        return Math.min(this.max, Math.max(0, position + distance));
      });
      this.pendingIndex = null;
      if (this.nav) this.nav.hidden = this.max < 2;
      this.update();
    }

    scheduleMeasure() {
      cancelAnimationFrame(this.measureFrame);
      this.measureFrame = requestAnimationFrame(() => this.measure());
    }

    index() {
      if (!this.positions?.length || this.max < 2) return 0;
      if (this.position >= this.max - 2) return this.cards.length - 1;
      let nearest = 0;
      let distance = Infinity;
      this.positions.forEach((position, index) => {
        const difference = Math.abs(position - this.position);
        if (difference < distance) {
          distance = difference;
          nearest = index;
        }
      });
      return nearest;
    }

    go(direction) {
      if (this.max < 2) return;
      const index = this.pendingIndex ?? this.index();
      let target = Math.max(0, Math.min(this.cards.length - 1, index + direction));
      while (target > 0 && target < this.cards.length - 1 && Math.abs(this.positions[target] - this.positions[index]) < 2) {
        target += direction;
      }
      this.moveTo(target, this.motion.matches ? 'auto' : 'smooth');
    }

    moveTo(index, behavior) {
      if (!this.cards.length) return;
      index = Math.max(0, Math.min(this.cards.length - 1, index));
      this.pendingIndex = index;
      const left = this.positions[index] * (this.rtl ? -1 : 1);
      this.track.scrollTo({ left, behavior });
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.finishScroll(), 250);
      this.update();
    }

    onScroll() {
      if (!this.frame) this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.finishScroll(), 180);
    }

    finishScroll() {
      clearTimeout(this.settleTimer);
      this.pendingIndex = null;
      this.update();
    }

    interrupt() {
      this.pendingIndex = null;
      clearTimeout(this.settleTimer);
    }

    onKey(event) {
      if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
      const direction = { ArrowRight: this.rtl ? -1 : 1, ArrowLeft: this.rtl ? 1 : -1 }[event.key];
      if (direction) {
        event.preventDefault();
        this.go(direction);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        this.moveTo(event.key === 'Home' ? 0 : this.cards.length - 1, this.motion.matches ? 'auto' : 'smooth');
      }
    }

    update() {
      const index = this.index();
      const pad = (number) => String(number).padStart(2, '0');
      const value = `${pad(index + 1)} / ${pad(this.cards.length)}`;
      if (this.count && this.count.textContent !== value) this.count.textContent = value;
      const target = this.pendingIndex == null ? this.position : this.positions[this.pendingIndex];
      if (this.prev) this.prev.disabled = this.max < 2 || target <= 1;
      if (this.next) this.next.disabled = this.max < 2 || target >= this.max - 2;
      if (this.progress) {
        const total = this.max + this.track.clientWidth;
        const fraction = total > 0 ? Math.min(1, (this.position + this.track.clientWidth) / total) : 1;
        this.progress.style.setProperty('--arr-progress', fraction);
      }
    }

    pauseVideo(video) {
      if (!video.paused) {
        this.managedPause.add(video);
        video.pause();
      }
    }

    syncVideos() {
      const allowed = this.dataset.autoplay === 'true' && !this.motion.matches && !this.connection?.saveData && !document.hidden;
      this.videos.forEach((video) => {
        if (document.hidden || !this.visibleVideos.has(video)) this.pauseVideo(video);
        else if (!allowed) {
          if (this.autoPlaying?.has(video)) this.pauseVideo(video);
        } else if (!this.userPaused.has(video) && video.paused) {
          this.autoPlaying ||= new WeakSet();
          this.autoPlaying.add(video);
          video.muted = true;
          const promise = video.play();
          promise?.then(() => {
            if (!this.isConnected || document.hidden || !this.visibleVideos.has(video) || this.motion.matches || this.connection?.saveData) this.pauseVideo(video);
          }).catch(() => {});
        }
      });
    }
  }
  customElements.define('auro-reviews-carousel', AuroReviewsCarousel);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-science-backed-ingredients"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-ingredient-carousel-v4')) {
  class AuroIngredientCarousel extends HTMLElement {
    static states = new Map();
    static locks = new Set();
    static overflow = '';
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.signal = this.abort.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.dialog = this.querySelector('[data-dialog]');
      this.dialogBody = this.querySelector('[data-dialog-body]');
      this.animations = new Set();
      this.epoch = 0;
      this.stateKey = `${this.dataset.sectionId}:${this.dataset.default}`;
      this.state = AuroIngredientCarousel.states.get(this.stateKey) || { profile: this.dataset.default, filters: {} };
      this.state.filters ||= {};
      this.panels.forEach(panel => {
        panel.cards = [...panel.querySelectorAll('[data-card]')];
        const choices = new Set(panel.cards.map(card => card.dataset.category));
        panel.querySelectorAll('[data-filter]').forEach(button => { button.hidden = button.dataset.filter !== 'all' && !choices.has(button.dataset.filter); });
        const filters = panel.querySelector('[data-filters]');
        if (filters) filters.hidden = !panel.cards.length;
        const track = panel.querySelector('[data-track]');
        track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal: this.signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') track.scrollTo({ left: event.key === 'Home' ? 0 : this.direction(track) * track.scrollWidth, behavior: this.behavior() });
          else this.scroll(panel, event.key === 'ArrowRight' ? this.direction(track) : -this.direction(track));
        }, { signal: this.signal });
      });
      this.addEventListener('click', event => this.click(event), { signal: this.signal });
      this.addEventListener('keydown', event => this.tabKey(event), { signal: this.signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeDialog(); }, { signal: this.signal });
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.finishClose(); }, { signal: this.signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog();
      }, { signal: this.signal });
      document.addEventListener('shopify:block:select', event => {
        const card = this.querySelector(`[data-block-id="${CSS.escape(event.detail.blockId)}"]`);
        if (!card) return;
        const panel = card.closest('[data-panel]');
        this.select(panel.dataset.panel, false);
        this.filter(panel, 'all', false);
        const track = panel.querySelector('[data-track]');
        track.scrollTo({ left: this.cardPosition(track, card), behavior: 'auto' });
      }, { signal: this.signal });
      const tabList = this.querySelector('[data-tabs]');
      if (tabList) {
        tabList.hidden = false;
        tabList.setAttribute('role', 'tablist');
        this.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
        this.panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.tab === panel.dataset.panel).id);
        });
      }
      this.classList.add('is-enhanced');
      this.select(this.panels.some(panel => panel.dataset.panel === this.state.profile) ? this.state.profile : this.panels[0]?.dataset.panel, false);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this);
        this.panels.forEach(panel => this.resizeObserver.observe(panel.querySelector('[data-track]')));
      } else window.addEventListener('resize', () => this.scheduleUpdate(), { passive: true, signal: this.signal });
      if ('IntersectionObserver' in window) {
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.revealObserver.unobserve(entry.target);
            this.play(entry.target, [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }], 520);
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });
        this.querySelectorAll('[data-reveal]').forEach(element => this.revealObserver.observe(element));
      }
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.cancelAnimations(); }, { signal: this.signal });
      this.scheduleUpdate();
    }
    behavior() { return this.dataset.animate !== 'false' && !this.motion.matches ? 'smooth' : 'auto'; }
    direction(track) { return getComputedStyle(track).direction === 'rtl' ? -1 : 1; }
    save() { AuroIngredientCarousel.states.set(this.stateKey, this.state); }
    play(element, frames, duration) {
      if (this.dataset.animate === 'false' || this.motion.matches || !element.animate) return null;
      const animation = element.animate(frames, { duration, easing: 'cubic-bezier(.22,1,.36,1)' });
      this.animations.add(animation);
      animation.finished.catch(() => {}).finally(() => this.animations.delete(animation));
      return animation;
    }
    cancelAnimations() { this.animations.forEach(animation => animation.cancel()); this.animations.clear(); }
    select(profile, animate = true) {
      if (!profile) return;
      if (this.dialog.open) this.closeDialog(true);
      this.state.profile = profile;
      this.tabs.forEach(tab => {
        const active = tab.dataset.tab === profile;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.panel !== profile;
        if (!panel.hidden) this.filter(panel, this.state.filters[profile] || 'all', animate);
      });
      this.save();
    }
    filter(panel, category, animate = true) {
      if (category !== 'all' && !panel.cards.some(card => card.dataset.category === category)) category = 'all';
      panel.cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.category !== category; });
      panel.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
      this.state.filters[panel.dataset.panel] = category;
      this.save();
      const track = panel.querySelector('[data-track]');
      track.scrollTo({ left: 0, behavior: 'auto' });
      this.update(panel);
      if (animate) {
        this.panelAnimation?.cancel();
        this.panelAnimation = this.play(track, [{ opacity: .35, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], 280);
      }
      const status = this.querySelector('[data-status]');
      status.textContent = `${panel.cards.filter(card => !card.hidden).length} ${status.dataset.countLabel} · ${panel.dataset.label}`;
    }
    click(event) {
      const close = event.target.closest('[data-close]');
      if (close && this.contains(close)) { this.closeDialog(); return; }
      const tab = event.target.closest('[data-tab]');
      if (tab && this.contains(tab)) { this.select(tab.dataset.tab); return; }
      const filter = event.target.closest('[data-filter]');
      if (filter && this.contains(filter)) { this.filter(filter.closest('[data-panel]'), filter.dataset.filter); return; }
      const arrow = event.target.closest('[data-prev],[data-next]');
      if (arrow && this.contains(arrow)) { this.scroll(arrow.closest('[data-panel]'), arrow.hasAttribute('data-next') ? 1 : -1); return; }
      const trigger = event.target.closest('[data-open]');
      if (trigger && this.contains(trigger) && typeof this.dialog.showModal === 'function') { event.preventDefault(); this.openDialog(trigger); }
    }
    tabKey(event) {
      const tab = event.target.closest('[data-tab]');
      if (!tab || !this.contains(tab) || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const direction = getComputedStyle(tab).direction === 'rtl' ? -1 : 1;
      let index = this.tabs.indexOf(tab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = this.tabs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? direction : -direction) + this.tabs.length) % this.tabs.length;
      this.select(this.tabs[index].dataset.tab);
      this.tabs[index].focus({ preventScroll: true });
    }
    cardPosition(track, card) {
      const a = track.getBoundingClientRect(), b = card.getBoundingClientRect();
      return track.scrollLeft + (this.direction(track) === 1 ? b.left - a.left : b.right - a.right);
    }
    scroll(panel, direction) {
      const track = panel.querySelector('[data-track]');
      const card = panel.cards.find(item => !item.hidden);
      const distance = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth;
      track.scrollBy({ left: direction * distance * this.direction(track), behavior: this.behavior() });
    }
    scheduleUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.panels.filter(panel => !panel.hidden).forEach(panel => this.update(panel)); });
    }
    update(panel) {
      const track = panel.querySelector('[data-track]');
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const offset = Math.min(max, Math.max(0, Math.abs(track.scrollLeft)));
      const fraction = track.scrollWidth ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
      const ratio = max ? offset / max : 0;
      const progress = panel.querySelector('[data-progress]');
      const translated = (1 - fraction) * ratio * 100;
      progress.style.transform = this.direction(track) === 1 ? `translateX(${translated}%) scaleX(${fraction})` : `translateX(${100 - fraction * 100 - translated}%) scaleX(${fraction})`;
      panel.querySelector('[data-progress-track]').hidden = max < 3;
      panel.querySelector('[data-controls]').hidden = max < 3;
      panel.querySelector('[data-prev]').disabled = offset <= 2;
      panel.querySelector('[data-next]').disabled = offset >= max - 2;
      const visible = panel.cards.filter(card => !card.hidden);
      const step = visible[0] ? visible[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : 1;
      panel.querySelector('[data-position]').textContent = `${Math.min(visible.length, Math.round(offset / step) + 1)} / ${visible.length}`;
    }
    openDialog(trigger) {
      const content = trigger.closest('[data-card]').querySelector('[data-detail-content]');
      if (!content) return;
      this.epoch++;
      this.dialogAnimation?.cancel();
      this.dialogBody.replaceChildren(content.cloneNode(true));
      const heading = this.dialogBody.querySelector('[data-dialog-heading]');
      heading.id = `AuroIngDialogHeading-${this.dataset.sectionId}`;
      this.dialog.setAttribute('aria-labelledby', heading.id);
      this.lastTrigger = trigger;
      if (!this.dialog.open) this.dialog.showModal();
      this.dialog.scrollTop = 0;
      if (!AuroIngredientCarousel.locks.size) AuroIngredientCarousel.overflow = document.documentElement.style.overflow;
      AuroIngredientCarousel.locks.add(this);
      document.documentElement.style.overflow = 'hidden';
      this.dialog.querySelector('[data-close]').focus({ preventScroll: true });
      this.dialogAnimation = this.play(this.dialog, [{ opacity: 0, transform: 'translateY(14px) scale(.985)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }], 260);
    }
    closeDialog(immediate = false) {
      if (!this.dialog.open) return;
      const epoch = ++this.epoch;
      this.dialogAnimation?.cancel();
      const animation = immediate ? null : this.play(this.dialog, [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(8px)' }], 150);
      this.dialogAnimation = animation;
      const finish = () => { if (epoch === this.epoch && this.dialog.open) { this.dialog.close(); this.finishClose(); } };
      if (animation) animation.finished.catch(() => {}).then(finish); else finish();
    }
    finishClose(restore = true) {
      if (this.dialog.open) return;
      this.dialog.removeAttribute('aria-labelledby');
      this.dialogBody.replaceChildren();
      if (AuroIngredientCarousel.locks.has(this)) {
        AuroIngredientCarousel.locks.delete(this);
        if (!AuroIngredientCarousel.locks.size) document.documentElement.style.overflow = AuroIngredientCarousel.overflow;
      }
      const trigger = this.lastTrigger;
      this.lastTrigger = null;
      if (restore && trigger?.isConnected && !trigger.closest('[hidden]')) trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      if (!this.abort) return;
      this.abort.abort();
      this.abort = null;
      this.epoch++;
      this.cancelAnimations();
      this.resizeObserver?.disconnect();
      this.revealObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.dialog.open) this.dialog.close();
      this.finishClose(false);
    }
  }
  customElements.define('auro-ingredient-carousel-v4', AuroIngredientCarousel);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-science-complete-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-quality-page')) {
  customElements.define('auro-quality-page', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.seen = this.seen || new WeakSet();
      this.items = Array.from(this.querySelectorAll('[data-standard]'));
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.stage = this.querySelector('[data-stage]');
      this.stageLabel = this.querySelector('[data-stage-label]');
      this.standardsRegion = this.querySelector('[data-standards]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      const signal = this.events.signal;
      this.isWatchingStandards = false;
      this.activeId = null;
      this.onMotion = () => this.observeReveals();
      this.motion.addEventListener('change', this.onMotion);
      this.onScroll = () => {
        if (this.isWatchingStandards && !document.hidden) this.queueUpdate();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true, signal });
      window.addEventListener('resize', () => this.queueUpdate(), { passive: true, signal });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.queueUpdate();
      }, { signal });
      this.addEventListener('shopify:block:select', (event) => {
        const standard = event.target.closest?.('[data-standard]');
        if (standard && this.contains(standard)) this.setActive(standard);
        const reveal = event.target.matches?.('[data-reveal]') ? event.target : event.target.querySelector?.('[data-reveal]');
        if (reveal && this.contains(reveal) && this.dataset.motion === 'true' && !this.motion.matches) this.reveal(reveal, 0);
      }, { signal });
      if (this.standardsRegion && typeof IntersectionObserver !== 'undefined') {
        this.regionObserver = new IntersectionObserver((entries) => {
          if (!this.isConnected) return;
          this.isWatchingStandards = entries.some((entry) => entry.isIntersecting);
          if (this.isWatchingStandards) this.queueUpdate();
        }, { threshold: 0 });
        this.regionObserver.observe(this.standardsRegion);
      } else this.isWatchingStandards = !!this.standardsRegion;
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
        this.resizeObserver.observe(this);
      }
      this.observeReveals();
      this.queueUpdate();
    }
    observeReveals() {
      this.revealObserver?.disconnect();
      if (this.dataset.motion !== 'true' || this.motion.matches || typeof IntersectionObserver === 'undefined') return;
      this.revealObserver = new IntersectionObserver((entries) => {
        if (!this.isConnected || this.motion.matches) return;
        let index = 0;
        const delay = Math.max(0, Math.min(140, Number(this.dataset.stagger) || 0));
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.reveal(entry.target, Math.min(index++, 4) * delay);
          this.revealObserver.unobserve(entry.target);
        }
      }, { threshold: 0, rootMargin: '0px 0px -8px 0px' });
      this.querySelectorAll('[data-reveal]').forEach((node) => {
        if (!this.seen.has(node)) this.revealObserver.observe(node);
      });
    }
    reveal(node, delay) {
      if (this.seen.has(node)) return;
      this.seen.add(node);
      node.style.setProperty('--aqp-enter-delay', `${delay}ms`);
      node.classList.add('is-entering');
    }
    queueUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (this.isConnected) this.updateStandard();
      });
    }
    updateStandard() {
      if (!this.stage || !this.items.length || getComputedStyle(this.stage).display === 'none') return;
      const target = window.innerHeight * 0.45;
      let active = this.items[0];
      for (const item of this.items) {
        if (item.getBoundingClientRect().top <= target) active = item;
      }
      this.setActive(active);
    }
    setActive(active) {
      const id = active.dataset.standard;
      if (id === this.activeId) return;
      this.activeId = id;
      this.items.forEach((item) => item.classList.toggle('is-active', item === active));
      this.slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.slide === id));
      if (this.stageLabel) this.stageLabel.textContent = active.dataset.label || '';
    }
    disconnectedCallback() {
      this.events?.abort();
      this.regionObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

if (!customElements.get('auro-report-explorer')) {
  customElements.define('auro-report-explorer', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.entries = Array.from(this.querySelectorAll('[data-report-entry]'));
      this.input = this.querySelector('[data-report-search]');
      this.more = this.querySelector('[data-report-more]');
      this.status = this.querySelector('[data-report-status]');
      this.empty = this.querySelector('[data-report-empty]');
      this.controls = this.querySelector('[data-report-controls]');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.events = new AbortController();
      this.cap = this.initialLimit();
      const signal = this.events.signal;
      this.input?.addEventListener('input', () => {
        this.cap = this.initialLimit();
        this.update();
      }, { signal });
      this.more?.addEventListener('click', () => {
        const firstNew = this.matchesList?.[this.cap];
        this.cap += Math.max(1, Number(this.dataset.batch) || 6);
        this.update();
        const link = firstNew?.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      }, { signal });
      this.onBreakpoint = () => {
        this.cap = this.initialLimit();
        this.update();
      };
      this.mobile.addEventListener('change', this.onBreakpoint);
      this.addEventListener('shopify:block:select', (event) => {
        const row = event.target.closest?.('[data-report-entry]');
        if (!row || !this.contains(row)) return;
        if (this.input) this.input.value = '';
        this.cap = this.entries.length;
        this.update();
      }, { signal });
      if (this.controls) this.controls.hidden = !this.entries.length;
      this.update();
    }
    initialLimit() {
      if (window.Shopify?.designMode || !this.mobile?.matches || this.dataset.paginate !== 'true') return Infinity;
      return Math.max(1, Number(this.dataset.initial) || 6);
    }
    normalized(value) {
      return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }
    update() {
      const query = this.normalized(this.input?.value || '');
      this.matchesList = this.entries.filter((entry) => this.normalized(entry.textContent || '').includes(query));
      const visible = new Set(this.matchesList.slice(0, this.cap));
      this.entries.forEach((entry) => { entry.hidden = !visible.has(entry); });
      if (this.more) this.more.hidden = this.matchesList.length <= this.cap;
      if (this.empty) this.empty.hidden = this.matchesList.length > 0;
      if (this.status) this.status.textContent = `${this.dataset.showing || 'Showing'} ${visible.size} ${this.dataset.of || 'of'} ${this.matchesList.length} ${this.dataset.reports || 'reports'}`;
    }
    disconnectedCallback() {
      this.events?.abort();
      if (this.mobile && this.onBreakpoint) this.mobile.removeEventListener('change', this.onBreakpoint);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auro-science-ingredients"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('auro-ingredients')) {
  customElements.define('auro-ingredients', class extends HTMLElement {
    static locks = new Set();
    static savedOverflow = '';
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.controller) this.setup(); });
    }
    setup() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.targets = new Map();
      this.scrollTimers = new Map();
      this.dialogOpeners = new WeakMap();
      this.frame = 0;
      this.panels.forEach(panel => {
        const tab = this.tabs.find(item => item.dataset.tab === panel.dataset.panel);
        if (!tab) return;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.removeAttribute('tabindex');
        tab.hidden = Number(panel.dataset.count) === 0;
        const track = panel.querySelector('[data-track]');
        if (!track) return;
        track.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
        track.addEventListener('scrollend', () => this.clearScrollTarget(track), { signal });
        ['pointerdown', 'wheel'].forEach(type => track.addEventListener(type, () => this.clearScrollTarget(track), { passive: true, signal }));
      });
      const visible = this.tabs.filter(tab => !tab.hidden);
      const tablist = this.querySelector('.ai-tabs');
      if (tablist) tablist.hidden = visible.length < 2;
      this.toggleAttribute('data-single-group', visible.length === 1);
      this.setAttribute('data-enhanced', '');
      if (typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function') {
        this.querySelectorAll('[data-open-dialog]').forEach(button => { button.hidden = false; });
        this.querySelectorAll('.ai-fallback-details').forEach(details => { details.hidden = true; });
      }
      this.addEventListener('pointerdown', event => {
        const dialog = event.target.closest('dialog[open]');
        this.backdropPress = dialog && event.target === dialog && this.outside(dialog, event);
      }, { signal });
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-tab]');
        if (tab) { this.activate(tab.dataset.tab); return; }
        const next = event.target.closest('[data-next]');
        const previous = event.target.closest('[data-previous]');
        if (next || previous) {
          const button = next || previous;
          if (button.disabled) return;
          const track = button.closest('[data-panel]').querySelector('[data-track]');
          this.move(track, next ? 1 : -1);
          return;
        }
        const opener = event.target.closest('[data-open-dialog]');
        if (opener) { this.openDialog(opener); return; }
        const closer = event.target.closest('[data-close-dialog]');
        if (closer) { closer.closest('dialog')?.close(); return; }
        if (this.backdropPress && event.target.matches('dialog[open]') && this.outside(event.target, event)) event.target.close();
        this.backdropPress = false;
      }, { signal });
      this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => this.unlock(dialog), { signal }));
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-tab]');
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        if (tab) {
          event.preventDefault();
          const tabs = this.tabs.filter(item => !item.hidden);
          if (!tabs.length) return;
          const rtl = getComputedStyle(tab).direction === 'rtl';
          let index = tabs.indexOf(tab);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = tabs.length - 1;
          else index = (index + (event.key === 'ArrowRight' ? (rtl ? -1 : 1) : (rtl ? 1 : -1)) + tabs.length) % tabs.length;
          tabs[index].focus({ preventScroll: true });
          this.activate(tabs[index].dataset.tab);
        } else if (event.target.matches('[data-track]')) {
          event.preventDefault();
          const track = event.target;
          const rtl = getComputedStyle(track).direction === 'rtl';
          if (event.key === 'Home') this.scrollToOffset(track, 0);
          else if (event.key === 'End') this.scrollToOffset(track, track.scrollWidth - track.clientWidth);
          else this.move(track, event.key === 'ArrowRight' ? (rtl ? -1 : 1) : (rtl ? 1 : -1));
        }
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const item = event.target.closest('[data-ingredient-group]');
        if (!item) return;
        this.activate(item.dataset.ingredientGroup);
        const track = item.closest('[data-track]');
        const a = item.getBoundingClientRect();
        const b = track.getBoundingClientRect();
        const rtl = getComputedStyle(track).direction === 'rtl';
        track.scrollBy({ left: rtl ? a.right - b.right : a.left - b.left, behavior: 'instant' });
      }, { signal });
      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(() => this.schedule());
        this.querySelectorAll('[data-track]').forEach(track => this.observer.observe(track));
      } else window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
      const defaultTab = visible.find(tab => tab.dataset.tab === this.dataset.defaultTab) || visible[0];
      if (defaultTab) this.activate(defaultTab.dataset.tab);
      else this.panels.forEach(panel => { panel.hidden = true; });
    }
    outside(dialog, event) {
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }
    motion() { return this.hasAttribute('data-animate') && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'; }
    activate(group) {
      if (!this.tabs.some(tab => tab.dataset.tab === group && !tab.hidden)) return;
      if (this.activeDialog?.open) { const dialog = this.activeDialog; this.unlock(dialog, false); dialog.close(); }
      this.tabs.forEach(tab => {
        const active = tab.dataset.tab === group && !tab.hidden;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== group; });
      this.schedule();
    }
    move(track, direction) {
      if (!track) return;
      const card = track.querySelector('.ai-item');
      const step = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0) : track.clientWidth;
      this.scrollToOffset(track, (this.targets.get(track) ?? Math.abs(track.scrollLeft)) + step * direction);
    }
    scrollToOffset(track, offset) {
      const target = Math.max(0, Math.min(offset, track.scrollWidth - track.clientWidth));
      this.clearScrollTarget(track);
      this.targets.set(track, target);
      this.scrollTimers.set(track, setTimeout(() => this.clearScrollTarget(track), 800));
      const rtl = getComputedStyle(track).direction === 'rtl';
      track.scrollTo({ left: rtl ? -target : target, behavior: this.motion() });
    }
    clearScrollTarget(track) {
      clearTimeout(this.scrollTimers.get(track));
      this.scrollTimers.delete(track);
      this.targets.delete(track);
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
    }
    refresh() {
      const panel = this.panels.find(item => !item.hidden);
      const track = panel?.querySelector('[data-track]');
      if (!track) return;
      const carousel = panel.querySelector('.ai-carousel');
      const styles = getComputedStyle(carousel);
      const gutter = (parseFloat(styles.paddingLeft) || 0) + (parseFloat(styles.paddingRight) || 0);
      const naturalOverflow = track.scrollWidth - track.clientWidth - gutter;
      const showArrows = naturalOverflow > 2 && this.hasAttribute('data-show-arrows');
      carousel.classList.toggle('ai-carousel--static', !showArrows);
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const offset = Math.min(max, Math.max(0, Math.abs(track.scrollLeft)));
      const previous = panel.querySelector('[data-previous]');
      const next = panel.querySelector('[data-next]');
      if (previous) { previous.hidden = !showArrows; previous.disabled = offset <= 2; }
      if (next) { next.hidden = !showArrows; next.disabled = offset >= max - 2; }
      const progress = panel.querySelector('[data-progress]');
      if (progress) {
        const width = track.scrollWidth ? Math.min(100, track.clientWidth / track.scrollWidth * 100) : 100;
        const position = max ? offset / max * (100 - width) : 0;
        const rtl = getComputedStyle(track).direction === 'rtl';
        progress.style.width = `${width}%`;
        progress.style.left = `${rtl ? 100 - width - position : position}%`;
        progress.parentElement.hidden = max <= 2;
      }
    }
    openDialog(opener) {
      const dialog = document.getElementById(opener.dataset.openDialog);
      if (!dialog || !this.contains(dialog) || dialog.open || typeof dialog.showModal !== 'function') return;
      if (this.activeDialog?.open) { const current = this.activeDialog; this.unlock(current, false); current.close(); }
      try { dialog.showModal(); } catch { return; }
      this.dialogOpeners.set(dialog, opener);
      if (!this.constructor.locks.size) this.constructor.savedOverflow = document.documentElement.style.overflow;
      this.constructor.locks.add(dialog);
      document.documentElement.style.overflow = 'hidden';
      this.activeDialog = dialog;
    }
    unlock(dialog, restoreFocus = true) {
      if (!dialog || !this.constructor.locks.delete(dialog)) return;
      if (!this.constructor.locks.size) document.documentElement.style.overflow = this.constructor.savedOverflow;
      if (this.activeDialog === dialog) this.activeDialog = null;
      const opener = this.dialogOpeners.get(dialog);
      this.dialogOpeners.delete(dialog);
      if (restoreFocus && opener?.isConnected && !opener.closest('[hidden]')) opener.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      if (this.activeDialog) { const dialog = this.activeDialog; this.unlock(dialog, false); if (dialog.open) dialog.close(); }
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.scrollTimers?.forEach(timer => clearTimeout(timer));
      this.scrollTimers?.clear();
      this.targets?.clear();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
